var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___LXEyS2",
  "jf": "VoiceConnectionStatus.module__statusRow___LXEyS2",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___LXEyS2",
  "kR": "VoiceConnectionStatus.module__signalIcon___LXEyS2",
  "rI": "VoiceConnectionStatus.module__statusButton___LXEyS2",
  "QQ": "VoiceConnectionStatus.module__statusConnected___LXEyS2",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___LXEyS2",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___LXEyS2",
  "ne": "VoiceConnectionStatus.module__controls___LXEyS2",
  "uH": "VoiceConnectionStatus.module__controlButton___LXEyS2",
  "wH": "VoiceConnectionStatus.module__selected___LXEyS2",
  "Kk": "VoiceConnectionStatus.module__icon___LXEyS2",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___LXEyS2",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___LXEyS2",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___LXEyS2",
  "_R": "VoiceConnectionStatus.module__channelSourceText___LXEyS2",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___LXEyS2",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___LXEyS2",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___LXEyS2",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___LXEyS2",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___LXEyS2",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___LXEyS2",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___LXEyS2",
  "EU": "VoiceConnectionStatus.module__mediaSection___LXEyS2",
  "LA": "VoiceConnectionStatus.module__mediaButton___LXEyS2",
  "A1": "VoiceConnectionStatus.module__cameraActive___LXEyS2",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___LXEyS2",
  "oz": "VoiceConnectionStatus.module__roomActive___LXEyS2",
  "cU": "VoiceConnectionStatus.module__mediaIcon___LXEyS2",
  "DO": "VoiceConnectionStatus.module__roomNewBadge___LXEyS2",
  "Cx": "VoiceConnectionStatus.module__roomNewBadgeShimmer___LXEyS2",
  "jC": "VoiceConnectionStatus.module__popoutContainer___LXEyS2",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___LXEyS2",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___LXEyS2",
  "hY": "VoiceConnectionStatus.module__popoutHeader___LXEyS2",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___LXEyS2",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___LXEyS2",
  "nO": "VoiceConnectionStatus.module__popoutStats___LXEyS2",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___LXEyS2",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___LXEyS2",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___LXEyS2",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___LXEyS2",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___LXEyS2",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___LXEyS2",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___LXEyS2",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___LXEyS2",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___LXEyS2",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___LXEyS2",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___LXEyS2",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___LXEyS2",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___LXEyS2",
  "mp": "VoiceConnectionStatus.module__deviceBadge___LXEyS2",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___LXEyS2",
  "hn": "VoiceConnectionStatus.module__endpointBadge___LXEyS2",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___LXEyS2",
  "_v": "VoiceConnectionStatus.module__chartContainer___LXEyS2",
  "nS": "VoiceConnectionStatus.module__chartSvg___LXEyS2",
  "$s": "VoiceConnectionStatus.module__gridLine___LXEyS2",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___LXEyS2",
  "eB": "VoiceConnectionStatus.module__gridText___LXEyS2",
  "BC": "VoiceConnectionStatus.module__chartLine___LXEyS2",
  "Pi": "VoiceConnectionStatus.module__chartPoint___LXEyS2",
  "Hh": "VoiceConnectionStatus.module__textGreen___LXEyS2",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___LXEyS2",
  "Bx": "VoiceConnectionStatus.module__iconSmall___LXEyS2",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___LXEyS2",
  "hz": "VoiceConnectionStatus.module__lockIcon___LXEyS2",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___LXEyS2",
  "uU": "VoiceConnectionStatus.module__nsOptions___LXEyS2",
  "Ot": "VoiceConnectionStatus.module__nsSliderSection___LXEyS2",
  "Pq": "VoiceConnectionStatus.module__nsSliderLabel___LXEyS2",
  "nj": "VoiceConnectionStatus.module__nsSliderTitleRow___LXEyS2",
};

module.exports = exports;
